import ExternalFunnel from 'components/Shared/ExternalFunnel/ExternalFunnel';
import type { ExternalFunnelProps } from 'components/Shared/ExternalFunnel/ExternalFunnel';
import type { FC } from 'react';
import type { IBlockFunnel } from 'types/contentful/generated';

type Props = IBlockFunnel & ExternalFunnelProps;

const BlockFunnel: FC<Props> = ({ sys, config, useShadow, onInteraction }) => {
  return (
    <ExternalFunnel
      funnelId={sys.id}
      config={config}
      useShadow={useShadow}
      onInteraction={onInteraction}
    />
  );
};

export default BlockFunnel;
